"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.stats.total': 'Total Onboardings',
    'onboarding.stats.in_progress': 'In Progress',
    'onboarding.stats.completed': 'Completed',
    'onboarding.stats.avatars_created': 'Avatars Created',
};
